import React from 'react';
import { CountryDropdown } from 'react-country-region-selector';
import PhoneInput from 'react-phone-input-2';

import { FormHandler, Label, Input, Textarea, Checkbox } from 'Components/Form';
import { Alert } from 'Components/Partials';
import { RedButton } from 'Components/Button';
import RegistrationLayout from 'Components/Layouts/RegistrationLayout';
import { Redirect } from 'react-router-dom';

import Me from 'Services/Api/Me/Me';
import { User } from 'Services';
import { asset } from 'Services/BaseHelpers';
import { Link } from "Components/Utilities";
import Dietaries from "Components/Form/Dietaries";
import Auth from "Components/Layouts/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";

class Profile extends React.Component {
    /**
     * @var state
     * @type {{showSuccess: boolean}}
     */
    state = {
        showSuccess: false,
        attending: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        if (User.data.attending === null) {
            this.props.setForm(User.data);
        } else {
            this.setState({
                showSuccess: true,
                attending: User.data.attending,
            });
        }
    };

    /**
     * @method success
     */
    success = (response) => {
        //User.data.attending = response.data.data.attending;
        User.refresh();
        this.setState({
            showSuccess: true,
            attending: response.data.data.attending,
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            form,
            alert,
            working,
            handleInput,
            handleSubmit,
        } = this.props;
        const { showSuccess, attending } = this.state;

        if (showSuccess) {
            return this.renderSuccess();
        }

        return (
            <Auth customHeader={this.header()} containerWidth="w-full" containerPadding={"0"}>
                <RegistrationLayout attending={attending}>
                        <div className="mt-8">

                            <h2 className="text-black text-6xl text-center my-8 font-gilroy font-medium">
                                Register today
                            </h2>

                            <p className="text-lg text-center font-gilroy mb-8 font-medium">
                                Please complete the following registration form to secure your place at our virtual launch.
                            </p>

                            <form
                                onSubmit={e => handleSubmit(e, (data) => Me.profile(data, null), this.success)}
                            >
                                {alert && <Alert {...alert} />}
                                <div className="grid md:grid-cols-2 gap-2 mb-4">
                                    <div>
                                        <Input
                                            label="First Name"
                                            value={form.first_name}
                                            onChange={(v) => handleInput('first_name', v)}
                                            app={true}
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            label="Last Name"
                                            value={form.last_name}
                                            onChange={(v) => handleInput('last_name', v)}
                                            app={true}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <Input
                                        label="Email Address"
                                        value={form.email}
                                        type="email"
                                        onChange={(v) => handleInput('email', v)}
                                        app={true}
                                    />
                                </div>

                                {/*<div className="grid md:grid-cols-2 gap-2 mb-4">
                                    <div>
                                        <Label label="Contact Number" app={true} />

                                        <div className="country-code-dropdown">
                                            <PhoneInput
                                                containerClass="rounded-full px-4 bg-white py-1 font-gilroy"
                                                buttonClass="border-none"
                                                country="gb"
                                                value={form.contact_number ?? ''}
                                                onChange={phone => handleInput('contact_number', phone)}
                                                enableAreaCodes={true}
                                            />
                                        </div>
                                    </div>
                                </div>*/}

                                {/*<div className="flex items-center mb-8">
                                    <Label label="Are you a Pentland Employee?" app={true} className="mr-16 mb-0" />

                                    <Checkbox
                                        label="Yes"
                                        labelPlacement="right"
                                        app={true}
                                        value={form.pentland_employee}
                                        onChange={() => handleInput('pentland_employee', true)}
                                        containerClassName="mr-4"
                                    />
                                    <Checkbox
                                        label="No"
                                        labelPlacement="right"
                                        app={true}
                                        value={form.pentland_employee === false}
                                        onChange={() => handleInput('pentland_employee', false)}
                                    />
                                </div>*/}

                                    {/*{form.pentland_employee === false && (*/}
                                <div className="grid md:grid-cols-2 gap-2 mb-4">
                                    <div>
                                        <Label label="Country" app={true} />

                                        <CountryDropdown
                                            value={form.country ?? ''}
                                            onChange={(val) => handleInput('country', val)}
                                            classes={'w-full border-none rounded-full font-gilroy py-3'}
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            label="Company"
                                            value={form.company}
                                            onChange={(v) => handleInput('company', v)}
                                            app={true}
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            label="Job Title"
                                            value={form.job_title}
                                            onChange={(v) => handleInput('job_title', v)}
                                            app={true}
                                        />
                                    </div>
                                </div>

                                <div className="flex items-center mb-8">
                                    <Label
                                        label="Can you attend the virtual launch?"
                                        app={true}
                                        className="mr-16 mb-0"
                                    />

                                    <Checkbox
                                        label="Yes"
                                        labelPlacement="right"
                                        app={true}
                                        value={form.attending}
                                        onChange={() => handleInput('attending', true)}
                                        containerClassName="mr-4"
                                    />
                                    <Checkbox
                                        label="No"
                                        labelPlacement="right"
                                        app={true}
                                        value={form.attending === false}
                                        onChange={() => handleInput('attending', false)}
                                    />
                                </div>
                                {form.attending === false && (
                                    <div className="mb-8">
                                        <Textarea
                                            label="Please let us know why you’re unable to attend"
                                            rows={6}
                                            app={true}
                                            value={form.reason}
                                            onChange={(v) => handleInput('reason', v)}
                                        />
                                    </div>
                                )}

                                {/*{form.attending && (*/}
                                {/*    <React.Fragment>*/}
                                {/*        <div className="grid md:grid-cols-2 gap-4 mb-4">*/}
                                {/*            <div className="mb-4">*/}
                                {/*                <Dietaries*/}
                                {/*                    label="Do you have any dietary requirements?"*/}
                                {/*                    value={form?.dietaries}*/}
                                {/*                    onChange={(v) => handleInput('dietaries', v)}*/}
                                {/*                />*/}
                                {/*            </div>*/}

                                {/*            <div className="mb-4">*/}
                                {/*                <Input*/}
                                {/*                    label="Special access requirements "*/}
                                {/*                    app={true}*/}
                                {/*                    value={form.special_requirements}*/}
                                {/*                    onChange={(v) => handleInput('special_requirements', v)}*/}
                                {/*                />*/}
                                {/*            </div>*/}
                                {/*        </div>*/}

                                {/*        /!*<p className={"mb-8"}>*!/*/}
                                {/*        /!*    Emergency contact details*!/*/}
                                {/*        /!*</p>*!/*/}
                                {/*        /!*<div className="grid md:grid-cols-2 gap-8 mb-8">*!/*/}
                                {/*        /!*    <div>*!/*/}
                                {/*        /!*        <Input*!/*/}
                                {/*        /!*            label="Name"*!/*/}
                                {/*        /!*            value={form.emergency_contact_name}*!/*/}
                                {/*        /!*            onChange={(v) => handleInput('emergency_contact_name', v)}*!/*/}
                                {/*        /!*            app={true}*!/*/}
                                {/*        /!*        />*!/*/}
                                {/*        /!*    </div>*!/*/}

                                {/*        /!*    <div>*!/*/}
                                {/*        /!*        <Input*!/*/}
                                {/*        /!*            label="Relationship to you"*!/*/}
                                {/*        /!*            value={form.emergency_contact_relationship}*!/*/}
                                {/*        /!*            onChange={(v) => handleInput('emergency_contact_relationship', v)}*!/*/}
                                {/*        /!*            app={true}*!/*/}
                                {/*        /!*        />*!/*/}
                                {/*        /!*    </div>*!/*/}
                                {/*        /!*    <div className="mb-8">*!/*/}
                                {/*        /!*        <Label label="Emergency Contact Number" app={true} />*!/*/}
                                {/*        /!*        <div className="country-code-dropdown">*!/*/}
                                {/*        /!*            <PhoneInput*!/*/}
                                {/*        /!*                containerClass="rounded-full px-4 bg-white py-1 font-gilroy"*!/*/}
                                {/*        /!*                buttonClass="border-none"*!/*/}
                                {/*        /!*                country="gb"*!/*/}
                                {/*        /!*                value={form.emergency_contact_number ?? ''}*!/*/}
                                {/*        /!*                onChange={phone => handleInput('emergency_contact_number', phone)}*!/*/}
                                {/*        /!*                enableAreaCodes={true}*!/*/}
                                {/*        /!*            />*!/*/}
                                {/*        /!*        </div>*!/*/}
                                {/*        /!*    </div>*!/*/}
                                {/*        /!*</div>*!/*/}
                                {/*        /!*<div className="flex items-center mb-8">*!/*/}
                                {/*        /!*    <Label*!/*/}
                                {/*        /!*        label="Filming will be taking place during the live launch, please tick here if you would like to opt out"*!/*/}
                                {/*        /!*        app={true}*!/*/}
                                {/*        /!*        className="mr-16 mb-0"*!/*/}
                                {/*        /!*    />*!/*/}

                                {/*        /!*    <Checkbox*!/*/}
                                {/*        /!*        app={true}*!/*/}
                                {/*        /!*        value={form.filming_opt_out}*!/*/}
                                {/*        /!*        onChange={() => handleInput('filming_opt_out', !form.filming_opt_out)}*!/*/}
                                {/*        /!*        containerClassName="mr-4"*!/*/}
                                {/*        /!*    />*!/*/}
                                {/*        /!*</div>*!/*/}
                                {/*    </React.Fragment>*/}
                                {/*)}*/}

                                <div className="w-full text-center mt-12 mb-20">
                                    <RedButton
                                        working={working}
                                        text="Save"
                                    />
                                </div>
                            </form>
                        </div>
                    </RegistrationLayout>
            </Auth>
        );
    }
    header = () => (
        <div className="">
        </div>
    );
    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess = () => {
        const { attending } = this.state;

        // if (attending) {
        //     return (
        //         <Redirect to="/" />
        //     );
        // }

        return (
            <Auth customHeader={this.header()} containerWidth="w-full" containerPadding={"0"}>
                <RegistrationLayout attending={attending}>
                    <div className="max-w-4xl mx-auto">
                        {attending && (
                            <React.Fragment>
                                <div className="text-app-gray-text text-2xl md:text-5xl my-8 font-gilroy font-normal">
                                    <div className={"w-full text-center"}>
                                        You have successfully
                                    </div>
                                    <div className={"w-full text-center"}>
                                        registered to attend the
                                    </div>

                                    <div className={"w-full m-1   text-center"}>
                                        S2 2024
                                    </div>

                                    <div className={"w-full  text-center"}>
                                         Speedo Virtual Launch
                                    </div>
                                </div>

                                <p className="text-md text-app-gray-text  text-center font-gilroy mb-8 font-medium">
                                    A confirmation email has been sent to your email address. If you do not see the email
                                    in a few minutes, please check your junk inbox in case it has slipped into this folder.
                                </p>

                                <p className="text-center text-app-gray-text font-gilroy mb-8 font-medium">
                                    Joining instructions will be sent on the 18th October.
                                </p>

                                <p className="text-center text-app-gray-text font-gilroy mb-8 font-medium">
                                    Please visit the FAQS page to find out more.
                                </p>

                                {/*{User.data.timezone && (*/}
                                {/*    <p className="text-center font-gilroy mb-8"><a*/}
                                {/*        href={`/ics/${User.data.timezone.toLowerCase()}.ics`} className="font-bold">Don’t*/}
                                {/*        forget to block out the time in your calendar.</a></p>*/}
                                {/*)}*/}

                                <p className="text-center font-gilroy mb-8">
                                    If your query isn’t answered in the
                                    {" "}
                                    <Link to="/faq"
                                          className="font-gilroy">
                                            FAQs
                                    </Link>
                                    {" "}
                                    please contact
                                    {" "}
                                    <a
                                        className="font-bold"
                                        href="mailto:info@speedolaunch.com">
                                         info@speedolaunch.com
                                    </a>.
                                </p>

                            </React.Fragment>
                        )}

                        {!attending && (
                            <React.Fragment>
                                <p className="text-lg font-bold text-center font-gilroy mb-8">
                                    Thank you for letting us know you are unable to attend the S2 2024. All content will be
                                    available for you to watch on 26th October 2023 on
                                    {" "}
                                    <Link to={process.env.MIX_APP_URL} >www.speedolaunch.com</Link>
                                </p>
                                <p className="text-lg font-bold text-center font-gilroy mb-8">
                                    A confirmation email has been sent to your email address. If you do not see the email
                                    in a few minutes, please check your junk inbox in case it has slipped into this folder.
                                </p>
                                <p className="text-lg text-center font-gilroy font-bold mb-8">
                                    If your circumstances change you can amend registration  up until 23rd October,
                                    after this please contact
                                    {" "}
                                    <a className="font-bold link"
                                       href="mailto:info@speedolaunch.com">
                                        info@speedolaunch.com
                                    </a>
                                </p>
                            </React.Fragment>
                        )}
                    </div>
                </RegistrationLayout>
            </Auth>
        );
    }
}

export default FormHandler(Profile);
